import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {DatepickerModule} from 'ng2-bootstrap/datepicker';
import {DropdownModule} from 'ng2-bootstrap/dropdown';
import {TooltipModule} from 'ng2-bootstrap/tooltip';

import {LeadaDatepickerComponent} from './leada-datepicker.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DatepickerModule.forRoot(),
    DropdownModule.forRoot(),
    TooltipModule.forRoot(),
  ],
  declarations: [
    LeadaDatepickerComponent,
  ],
  exports: [
    LeadaDatepickerComponent,
  ],
})
export class LeadaDatepickerModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/leada-datepicker/leada-datepicker.module.ts